import { useEffect } from 'react';
import { useAuth } from '@/auth/AuthProvider';
import { setApiFetchTokenGetter } from '@/lib/apiFetch';
import { setAuthTokenGetter } from './meApi';

/**
 * Component that initializes the auth token getters for meApi + apiFetchRaw.
 * Must be rendered inside AuthProvider.
 *
 * Post-MA.18 polish pack (2026-06-10): also publishes the token getter to
 * the module-level cache that `apiFetchRaw` reads. Pre-fix `apiFetchRaw`
 * silently skipped auth headers and every call 401'd against authenticated
 * endpoints (provider choropleth, MA.18 T.3 tract render, etc.).
 */
// SEC.2 T.3: auth-path debug logs gated behind VITE_DEBUG_LOGS.
const DEBUG = import.meta.env?.VITE_DEBUG_LOGS === '1';

export function AuthInitializer({ children }: { children: React.ReactNode }) {
  const { getIdToken } = useAuth();

  useEffect(() => {
    // Wire up the token getter for meApi (legacy path) + apiFetchRaw (new path).
    setAuthTokenGetter(getIdToken);
    setApiFetchTokenGetter(async () => {
      const t = await getIdToken();
      return t ?? null;
    });
    if (DEBUG) console.log('[AuthInitializer] Token getter initialized (meApi + apiFetchRaw)');
  }, [getIdToken]);

  return <>{children}</>;
}

